import { render, staticRenderFns } from "./FnFormatEmail.vue?vue&type=template&id=4ca8886c&"
import script from "./FnFormatEmail.vue?vue&type=script&lang=js&"
export * from "./FnFormatEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports